import { useEffect } from 'react';
import useGenerateInventoryRequest from '~/hooks/srp/useGenerateInventoryRequest';

/**
 * Manages the merchMaintainScrollPosition sessionStorage flag.
 *
 * On beforeunload (e.g. user clicks a tile to navigate to VDP), the flag is set so that on return
 * (back-button-from-VDP), the SRP can detect it and skip its scroll-to-top behavior — preserving the
 * user's scroll position from before the VDP visit.
 *
 * The scroll-to-top on filter/page change is handled by useSyncUrl, not this hook.
 */

const merchMaintainScrollPosition = 'merchMaintainScrollPosition';

export default function useScrollToTop() {
  const { request } = useGenerateInventoryRequest(0);

  useEffect(() => {
    const saveScrollPosition = () => {
      sessionStorage.setItem(merchMaintainScrollPosition, 'true');
    };

    window.addEventListener('beforeunload', saveScrollPosition);

    return () => {
      window.removeEventListener('beforeunload', saveScrollPosition);
    };
  }, []);

  useEffect(() => {
    const shouldMaintainPosition = sessionStorage.getItem(
      merchMaintainScrollPosition
    );
    if (shouldMaintainPosition) {
      sessionStorage.removeItem(merchMaintainScrollPosition);
    }
  }, [request]);
}
